const pageName = { singular: 'Payment Setting Komchat', plural: 'Payment Setting Komchat' }

export default [
  {
    path: '/setting/payment',
    name: 'setting-payment-komchat',
    component: () => import('@/views/pages/komship/setting-kompship/payment-komchat/index.vue'),
    meta: {
      name: pageName.singular,
      routeToProfile: 'kompship-profile',
      resource: 'Setting Payment',
      action: 'manage',
      breadcrumb: [
        {
          text: pageName.plural,
          active: true,
        },
      ],
    },
  },
]
